<template>
  <div class="menu-page">
    <div class="menu-page-left">
      <div style="margin-top: 10px;">
        <a-button type="link" @click="addTitle" v-if="isEdit"
          ><a-icon type="plus" /> {{ titleText }}</a-button
        >
        <a-button
          type="link"
          @click="editTitle"
          v-if="treeData.length && currentItem.TitleId && isEdit"
          ><a-icon type="edit" />编辑标题</a-button
        >
        <a-input-search placeholder="标题" enter-button @search="onSearch" />
      </div>
      <div class="tree-box">
        <a-tree
          id="leftContent"
          ref="myTree"
          v-if="treeData != null"
          :treeData="treeData"
          :expanded-keys="expandedKeys"
          :selectedKeys="selectedKey"
          :auto-expand-parent="autoExpandParent"
          @select="onSelect"
          @expand="onExpand"
          @rightClick="delTitle"
        >
        </a-tree>
      </div>
    </div>
    <div class="menu-page-right">
      <div
        class="edit-btn"
        v-if="
          (user.IsVirtual && user.IsGroupSystem) ||
            user.CompanyId == '635662494509043712'
        "
      >
        <a-radio-group
          v-model="activeKey"
          button-style="solid"
          style="margin-right:20px"
          @change="changeRadio"
        >
          <a-radio-button value="1">
            鸿云
          </a-radio-button>
          <a-radio-button value="2">
            {{
              versionConfig.ZHIYUN_VERSION && appConfig.title
                ? appConfig.title
                : "智云Plus"
            }}
          </a-radio-button>
        </a-radio-group>
        编辑:
        <a-switch v-model="status" @change="onChange" />
        <!-- <a-button type="primary" @click="handleEdit" v-if="!isEdit"
          >编辑</a-button
        >
        <a-button type="danger" @click="cancelEdit" v-else>取消编辑</a-button> -->
      </div>

      <div class="menu-page-view">
        <div v-if="isEdit">
          <quill-editor
            ref="quillEditor"
            imgUploadUrl="Help_FileSave"
            v-model="editor"
            @focus="focusEditor"
          />
          <div class="sub-btn">
            <a-button
              type="primary"
              @click="onSubmit"
              :disabled="!currentItem.TitleId"
              >提交</a-button
            >
          </div>
        </div>
        <div
          v-html="content"
          class="content-area ql-editor"
          id="ContentArea"
          v-else-if="!isEdit && content"
        ></div>

        <div class="content-area no-data" v-else-if="!isEdit && !content">
          暂无数据！
        </div>
      </div>
    </div>
    <a-modal
      :title="title"
      :visible="visible"
      :maskClosable="false"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" :loading="confirmLoading" @click="handleOk"
          >保存</a-button
        >
      </template>

      <p style="margin:30px 0">
        标题：<a-input v-model="newTitle" style="width:80%"></a-input>
      </p>
    </a-modal>
    <a-modal
      title="查看图片"
      :visible="visibleImg"
      :width="imgWidth"
      :centered="true"
      @cancel="visibleImg = false"
      :footer="null"
    >
      <p v-html="showImg" class="img-sec"></p>
    </a-modal>
    <a-modal
      title="输入密码"
      :visible="visiblePass"
      :destroyOnClose="true"
      :maskClosable="false"
      @ok="passSubmit"
      @cancel="passCancel"
    >
      <a-form :form="form" layout="inline">
        <a-form-item label="密码">
          <a-input
            type="password"
            style="width:200px"
            v-decorator="[
              'Pass',
              { rules: [{ required: true, message: '请输入密码' }] }
            ]"
            placeholder="请输入密码"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      :title="null"
      :visible="visibleInfo"
      :maskClosable="false"
      width="450px"
      :footer="null"
      @cancel="visibleInfo = false"
    >
      <div class="tip-msgbox">
        <a-icon type="question-circle" />
        击左侧栏空白处，将失去编辑的内容，是否继续？
        <div class="btns">
          <a-button @click="visibleInfo = false">取消</a-button>
          <a-button type="primary" @click="continueAction">继续</a-button>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import QuillEditor from "@/components/tools/QuillEditor";
import { mapState } from "vuex";
import { cache } from "@/utils/common";
export default {
  name: "ParamSetting",
  components: { QuillEditor },
  data() {
    return {
      versionConfig,
      form: this.$form.createForm(this, { name: "coordinated" }),
      visiblePass: false,
      editor: "",
      treeData: [],
      user: null,
      expandedKeys: [],
      autoExpandParent: false,
      editStatus: false,
      newTitle: "",
      addSubTitle: false,
      selectedKey: [],
      currentItem: {},
      loading: false,
      title: "添加标题",
      visible: false,
      confirmLoading: false,
      titleText: "添加子标题",
      isEdit: false,
      content: "",
      showImg: "",
      visibleImg: false,
      imgWidth: "95%",
      status: false,
      Keyword: "",
      focusEditorStatus: false,
      visibleInfo: false,
      activeKey: "1"
    };
  },
  computed: {
    ...mapState({
      appConfig: state => state.app.appConfig
    })
  },
  created() {
    this.user = cache.get("user");
    this.getTreeData(0);
    document.addEventListener("click", e => {
      e.stopPropagation();
      this.$nextTick(() => {
        const leftCnt = document.getElementById("leftContent");
        // const _this = this;
        if (
          leftCnt &&
          leftCnt.contains(e.target) &&
          this.currentItem.TitleId &&
          this.isEdit
        ) {
          this.visibleInfo = true;
          // this.$confirm({
          //   title: "切换标题或点击左侧栏空白处，将失去编辑的内容，是否继续？",
          //   okText: "继续",
          //   onOk() {
          //     modalOn = false;
          //     _this.reset();
          //   },
          //   onCancel() {
          //     modalOn = false;
          //   }
          // });
        }
        const area = document.getElementById("ContentArea");
        if (area && area.contains(e.target) && e.target.tagName == "IMG") {
          this.visibleImg = true;
          const htm = e.target.outerHTML;
          var createDom = document.createElement("div");
          createDom.innerHTML = htm;
          createDom.firstElementChild.style = "width:auto";
          this.imgWidth =
            e.target.naturalWidth + 100 > document.body.clientWidth
              ? "95%"
              : "auto";
          this.showImg = createDom.innerHTML;
        }
      });
    });
  },
  methods: {
    changeRadio(/*key*/) {
      this.getTreeData(0);
    },
    continueAction() {
      this.visibleInfo = false;
      this.reset();
    },
    focusEditor() {
      this.focusEditorStatus = true;
    },
    onSearch(value) {
      this.Keyword = value;
      this.reset();
      this.getTreeData(0);
    },
    onChange(e) {
      this.visiblePass = e;
      if (e) {
        //
      } else {
        this.cancelEdit();
      }
    },
    passSubmit() {
      this.form.validateFields((err, values) => {
        if (!err) {
          if (values.Pass != "1368") {
            this.$message.error("密码不正确！");
            return false;
          }
          this.visiblePass = false;
          this.handleEdit();
        }
      });
    },
    passCancel() {
      this.isEdit = false;
      this.visiblePass = false;
      this.status = false;
    },
    handleEdit() {
      this.isEdit = true;
      this.addSubTitle = true;
      this.getEditorData(this.currentItem.TitleId);
    },
    cancelEdit() {
      const _this = this;
      this.$confirm({
        title: "确定取消编辑吗？",
        onOk() {
          _this.isEdit = false;
          _this.status = false;
          if (!_this.currentItem.TitleId) {
            _this.selectedKey = [_this.treeData[0].Id];
            _this.getEditorData(_this.treeData[0].Id);
          } else {
            _this.getEditorData(_this.currentItem.TitleId);
          }
        },
        onCancel() {
          _this.status = true;
        }
      });
    },
    reset() {
      this.selectedKey = [];
      this.setEditorData("");
      this.currentItem = {};
      this.addSubTitle = false;
      this.titleText = this.addSubTitle ? "添加子标题" : "添加标题";
    },
    onExpand(expandedKeys) {
      this.expandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    getEditorData(id) {
      this.$post("Help_GetContent", { Id: id }).then(res => {
        this.content = res.Data && res.Data.Content;
        this.currentItem = {
          ...this.currentItem,
          ...res.Data
        };
        if (this.isEdit) {
          if (res.Data && res.Data.Content) {
            this.setEditorData(res.Data.Content);
          } else {
            this.setEditorData("");
          }
        }
      });
    },
    setEditorData(data) {
      this.$nextTick(() => {
        if (this.$refs.quillEditor) {
          this.$refs.quillEditor.setData(data);
          let quill = this.$refs.quillEditor.getRef("myQuillEditor").quill;
          quill.enable(false);
          setTimeout(() => {
            quill.enable(true);
          }, 1000);
        }
      });
    },
    getTreeData(status) {
      this.treeData = [];

      const json = {
        PageIndex: 0,
        PageSize: 1000,
        Keyword: this.Keyword
      };
      if (
        (this.user && this.user.IsVirtual && this.user.IsGroupSystem) ||
        (this.user && this.user.CompanyId == "635662494509043712")
      ) {
        json.IsZYPlus = this.activeKey == "2";
      }
      this.$post("Help_GetTitle", json).then(res => {
        this.treeData = res.Data.map(v => {
          const children = this.buildChildren(v);
          let json = {
            ...v,
            title: v.Name,
            key: v.Id,
            children: children,
            addTitle: false
          };
          return json;
        });
        if (status == 0 && res.Data && res.Data.length) {
          // res.Data.forEach(el => {});
          this.expandedKeys = [];
          this.expandedKeys = this.expandAllIds(this.expandedKeys, res.Data);
          // this.expandedKeys = res.Data.map(v => v.Id);
          this.selectedKey = [res.Data[0].Id];
          this.getEditorData(res.Data[0].Id);
          this.addSubTitle = true;
        }
      });
    },
    expandAllIds(arr, data) {
      const _this = this;
      data.forEach(item => {
        arr.push(item.Id);
        if (item.ChildNode && item.ChildNode.length > 0) {
          arr = _this.expandAllIds(arr, item.ChildNode);
        }
      });
      return arr;
    },
    buildChildren(item) {
      let child = [];
      if (item.ChildNode && item.ChildNode.length) {
        child = item.ChildNode.map(el => {
          const children = this.buildChildren(el);
          return {
            ...el,
            title: el.Name,
            key: el.Id,
            children: children,
            addTitle: false
          };
        });
      }
      return child;
    },
    handleCancel(e) {
      e.stopPropagation();
      this.visible = false;
    },
    handleOk(e) {
      e.stopPropagation();
      const item = this.currentItem;
      let api = "Help_AddTitle";
      let json = {
        Type: "HelpDocumentTitle",
        Name: this.newTitle,
        Code: this.newTitle
      };
      if (
        (this.user && this.user.IsVirtual && this.user.IsGroupSystem) ||
        (this.user && this.user.CompanyId == "635662494509043712")
      ) {
        json.IsZYPlus = this.activeKey == "2";
      }
      if (this.editStatus) {
        api = "Help_EditTitle";
        json.Id = item.TitleId;
        json.ParentId = item.ParentId;
      } else if (this.addSubTitle) {
        json.ParentId = item.TitleId;
      } else {
        json.ParentId = "0";
      }
      this.confirmLoading = true;
      this.$post(api, json)
        .then(() => {
          // this.addStatus = false;
          this.$message.success("保存成功");
          this.currentItem.TitleName = this.newTitle;
          this.currentItem.Code = this.newTitle;
          this.visible = false;
          this.getTreeData();
          this.confirmLoading = false;
          if (item && item.TitleId) {
            if (!this.expandedKeys.includes(item.TitleId)) {
              this.expandedKeys.push(item.TitleId);
            }
          }
        })
        .catch(() => {
          this.confirmLoading = false;
        });
    },
    addTitle(e) {
      this.title = this.addSubTitle ? "添加子标题" : "添加标题";
      e.stopPropagation();
      this.visible = true;
      this.newTitle = "";
      this.editStatus = false;
    },
    editTitle(e) {
      e.stopPropagation();
      this.title = "修改标题";
      this.editStatus = true;
      this.visible = true;
      this.newTitle = this.currentItem.TitleName;
    },
    delTitle(e) {
      if (!this.isEdit) {
        return false;
      }
      e.event.stopPropagation();
      const _this = this;
      this.$confirm({
        title: "确认删除标题【" + e.node.title + "】吗？",
        onOk() {
          _this
            .$post("Help_DeleteTitle", {
              Id: e.node.eventKey
            })
            .then(() => {
              _this.editStatus = false;
              _this.visible = false;
              _this.$message.success("删除成功");
              _this.getTreeData();
            });
        }
      });
    },
    onSubmit() {
      const editorData = this.$refs.quillEditor.getData();
      let json = {
        TitleId: this.currentItem.TitleId,
        TitleName: this.currentItem.TitleName,
        Content: editorData
      };
      let api = "Help_AddContent";
      if (this.currentItem.Id) {
        //编辑
        json.Id = this.currentItem.Id;
        api = "Help_EditContent";
      }
      this.loading = true;
      this.$post(api, json)
        .then(() => {
          this.$message.success("保存成功");
          this.loading = false;
          this.focusEditorStatus = false;
          // this.isEdit = false;
          // this.getEditorData(this.currentItem.TitleId);
        })
        .catch(() => {
          this.loading = false;
          this.getEditorData(this.currentItem.TitleId);
        });
    },
    changeItem(e, selectedKeys) {
      const _this = this;
      let key = selectedKeys[0];
      _this.addSubTitle = e.selected;
      _this.titleText = _this.addSubTitle ? "添加子标题" : "添加标题";
      if (e.selected) {
        _this.selectedKey = selectedKeys;
        _this.currentItem = {
          TitleName: e.node.title,
          TitleId: key,
          ParentId: e.node.$parent.eventKey
        };
        _this.getEditorData(key);
      } else {
        _this.selectedKey = [];
        _this.setEditorData("");
        _this.currentItem = {};
      }
      _this.focusEditorStatus = false;
    },
    onSelect(selectedKeys, e) {
      e.nativeEvent.stopPropagation();
      const _this = this;
      if (
        this.isEdit &&
        selectedKeys.length &&
        selectedKeys[0] != _this.currentItem.TitleId &&
        _this.selectedKey.length
      ) {
        if (!this.focusEditorStatus) {
          _this.changeItem(e, selectedKeys);
        } else {
          this.$confirm({
            title: "是否继续？",
            content:
              "切换标题将失去编辑的内容，如需保存，请点击右下角【提交】按钮。",
            okText: "继续",
            onOk() {
              _this.changeItem(e, selectedKeys);
              // }
            },
            onCancel() {
              // _this.status = true;
            }
          });
        }
      } else {
        _this.changeItem(e, selectedKeys);
      }
    }
  }
};
</script>

<style lang="less" scoped>
.menu-page {
  width: 100%;
  display: flex;
  height: calc(100vh - 180px);
  overflow: auto;
  .tree-box {
    height: calc(100vh - 260px);
    overflow-y: auto;
    border-right: 1px solid #e8e8e8;
  }
  .menu-page-left {
    flex: 0 0 250px;
    max-width: 250px;
    min-width: 250px;
    width: 250px;
    height: 100%;
  }

  .menu-page-right {
    flex: 1 1;
    padding: 8px 40px;
    width: 100%;
    overflow: hidden;
    // overflow-y: auto;
    .menu-page-title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 20px;
      font-weight: 500;
      line-height: 28px;
      margin-bottom: 12px;
    }
    .menu-page-view {
      height: 96%;
      overflow: hidden;
      overflow-y: auto;
    }
  }
}
.sub-btn {
  margin: 10px 0;
  text-align: right;
}
/deep/.ql-editor {
  height: calc(100vh - 350px);
}
.content-area {
  background: #fafafa;
  padding: 10px;
  height: calc(100vh - 260px);
}
.edit-btn {
  text-align: right;
  margin-bottom: 10px;
}
.no-data {
  text-align: center;
  font-size: 16px;
}
.img-sec {
  max-height: calc(100vh - 150px);
  overflow: auto;
  text-align: center;
}
.tip-msgbox {
  margin: 56px 0 14px;
  font-size: 16px;
  color: #000;
  .anticon {
    color: #faad14;
    font-size: 22px;
    vertical-align: -5px;
    margin-right: 5px;
  }
  .btns {
    text-align: right;
    margin-top: 24px;
    button {
      margin-left: 8px;
    }
  }
}
</style>
